<script setup>
import { Head, Link } from '@inertiajs/vue3';
import { ref } from 'vue';
import FrontLayout from '@/Layouts/FrontLayout.vue';
import PageHero from '@/Components/Front/PageHero.vue';

const props = defineProps({
    setting: Object,
    faqs: Array,
});

const openAccordion = ref(null);

const toggleAccordion = (id) => {
    if (openAccordion.value === id) {
        openAccordion.value = null;
    } else {
        openAccordion.value = id;
    }
};
</script>

<template>
    <FrontLayout 
        :setting="setting" 
        title="FAQ Sewa Mobil Banyuwangi | Rental Mobil Banyuwangi"
        metaDescription="Pertanyaan yang sering diajukan tentang sewa mobil Banyuwangi dan rental mobil Banyuwangi. Temukan jawaban lengkap dari Gotransport."
    >
        <Head>

            <meta name="description" content="Pertanyaan yang sering diajukan tentang sewa mobil Banyuwangi dan rental mobil Banyuwangi. Temukan jawaban lengkap dari Gotransport." />
        </Head>

        <PageHero 
            title="Frequently Asked Questions"
            subtitle="Temukan jawaban untuk pertanyaan yang sering diajukan"
            :breadcrumbs="[
                { label: 'Beranda', url: '/' },
                { label: 'FAQ' }
            ]"
        />

        <section class="py-16 bg-white dark:bg-gray-900 min-h-[500px]">
             <div class="container mx-auto px-4 lg:px-6 xl:px-8 max-w-4xl">
                 <div class="text-center mb-10">
                    <h2 class="text-3xl font-bold text-gray-900 dark:text-white mb-2">FAQ Sewa & Rental Mobil Banyuwangi</h2>
                    <p class="text-gray-600 dark:text-gray-400">Jawaban untuk pertanyaan umum tentang layanan sewa mobil dan rental mobil di Banyuwangi</p>
                 </div>

                 <div class="space-y-4">
                     <div v-for="faq in faqs" :key="faq.id" class="border border-gray-200 dark:border-gray-700 rounded-lg overflow-hidden transition-all duration-200" :class="{'bg-blue-50 dark:bg-blue-900/20 border-blue-200 dark:border-blue-800': openAccordion === faq.id}">
                         <button 
                            @click="toggleAccordion(faq.id)"
                            class="w-full flex items-center justify-between p-4 text-left font-semibold text-gray-800 dark:text-gray-200 hover:text-blue-600 dark:hover:text-blue-400 focus:outline-none transition-colors"
                         >
                             <span>{{ faq.faq_question }}</span>
                             <i class="fa transition-transform duration-300" :class="openAccordion === faq.id ? 'fa-minus text-blue-600 dark:text-blue-400' : 'fa-plus text-gray-400 dark:text-gray-500'"></i>
                         </button>
                         <div 
                            v-show="openAccordion === faq.id"
                            class="px-4 pb-4 pt-0 text-gray-600 dark:text-gray-400 leading-relaxed"
                         >
                             <div class="pt-2 border-t border-blue-100/50 dark:border-blue-800/50" v-html="faq.faq_answer"></div>
                         </div>
                     </div>
                 </div>

                 <div class="mt-12 text-center p-8 bg-gray-50 dark:bg-gray-800 rounded-2xl border border-gray-100 dark:border-gray-700">
                     <h3 class="text-xl font-bold text-gray-900 dark:text-white mb-3">Masih ada pertanyaan lain?</h3>
                     <p class="text-gray-600 dark:text-gray-400 mb-6">Jangan ragu untuk menghubungi tim support kami untuk bantuan lebih lanjut.</p>
                     <Link href="/contact" class="inline-flex items-center gap-2 px-8 py-3 bg-blue-600 hover:bg-blue-700 text-white font-bold rounded-full transition-colors shadow-lg shadow-blue-600/20">
                         <i class="fa fa-envelope"></i>
                         <span>Hubungi Kami</span>
                     </Link>
                 </div>
             </div>
        </section>
    </FrontLayout>
</template>
